export const ApplicationBaseUrlList = {
  marginBrain:
    "https://wdadvantage-marginbrain-eugfe5d5e4cvfqe9.a01.azurefd.net",
  catman: "https://wdadvantage-catman-c8bvcdf9bjewh0da.a01.azurefd.net",
  demandBrain: "https://demandbrain-ep-g6f9c8dudga8fwas.a01.azurefd.net",
  rebateoptimizer:
    "https://wdadvantage-rebateoptimizer-pe-ajhwh8e5f2f5ffbp.a01.azurefd.net",
  consolidated:
    "https://wdadvantage-rebateoptimizer-pe-ajhwh8e5f2f5ffbp.a01.azurefd.net",
};

type MainNavbarMenuType = {
  id: number;
  title: string;
  route?: string;
  active?: boolean;
  subMenu?: MainNavbarSubMenuType[];
};

type MainNavbarSubMenuType = {
  id: number;
  title: string;
  items?: MainNavbaritemSubMenu[];
  route?: string;
  url?: string;
};

type MainNavbaritemSubMenu = {
  id: number;
  title: string;
  url: string;
};

export const MainNavbarMenu: MainNavbarMenuType[] = [
  {
    id: 1,
    title: "Home",
    route: "/",
  },
  {
    id: 2,
    title: "Alerts",
    route: "/alerts",
  },
  {
    id: 3,
    title: "Performance Metrics",
    route: "/performance-metrics",
  },
  {
    id: 4,
    title: "Planning",
    active: true,
    subMenu: [
      {
        id: 2,
        title: "Forecast Alerts",
        items: [
          {
            id: 1,
            title: "High Over-Forecasting",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=HighOverForecasting`,
          },
          {
            id: 2,
            title: "High Under-Forecasting",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=HighUnderForecasting`,
          },
          {
            id: 3,
            title: "Low Forecast Accuracy",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=LowForecastAccuracy`,
          },
          {
            id: 4,
            title: "High Outlier Correction",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=HighOutlierCorrection`,
          },
          {
            id: 5,
            title: "Volatile Forecast",
            url: `${ApplicationBaseUrlList.demandBrain}/forecast/forecast-alerts?alert=VolatileForecast`,
          },
        ],
      },
      {
        id: 3,
        title: "Inventory Alerts",
        items: [
          {
            id: 1,
            title: "Potential Overstock",
            url: `${ApplicationBaseUrlList.demandBrain}/inventory/inventory-alerts?alert=PotentialOverstock`,
          },
          {
            id: 2,
            title: "Potential Stockout",
            url: `${ApplicationBaseUrlList.demandBrain}/inventory/inventory-alerts?alert=PotentialStockout`,
          },
          {
            id: 3,
            title: "Ageing Inventory",
            url: `${ApplicationBaseUrlList.demandBrain}/inventory/inventory-alerts?alert=AgeingInventory`,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    title: "Category Management",
    subMenu: [
      {
        id: 2,
        title: "Sourcing & Strategic Supplier Negotiations",
        items: [
          {
            id: 1,
            title: "Supplier Consolidation",
            url: `${ApplicationBaseUrlList.catman}/supplier-consolidation`,
          },
          {
            id: 2,
            title: "Cost Optimization",
            url: `${ApplicationBaseUrlList.catman}/cost-optimization`,
          },
          {
            id: 3,
            title: "Rebate: Peer Benchmark",
            url: `${ApplicationBaseUrlList.catman}/opportunities`,
          },
        ],
      },
      {
        id: 3,
        title: "Assortment & Product",
        items: [
          {
            id: 1,
            title: "SKU Management",
            url: `${ApplicationBaseUrlList.catman}/sku-management`,
          },
          {
            id: 2,
            title: "Portfolio Gap",
            url: `${ApplicationBaseUrlList.catman}/portfolio`,
          },
        ],
      },
      {
        id: 4,
        title: "Commercial & Pricing",
        items: [
          {
            id: 1,
            title: "Commercial Optimization",
            url: `${ApplicationBaseUrlList.catman}/pricing`,
          },
          {
            id: 2,
            title: "Brand Cost Indexing",
            url: `${ApplicationBaseUrlList.marginBrain}/wlp`,
          },
        ],
      },
      {
        id: 5,
        title: "Category Profitability",
        items: [
          {
            id: 1,
            title: "Category Profitability",
            url: `${ApplicationBaseUrlList.catman}/profitability`,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    title: "Customer Profitability",
    subMenu: [
      {
        id: 2,
        title: "Customer Profitability Opportunity",
        items: [
          {
            id: 1,
            title: "Pricing",
            url: `${ApplicationBaseUrlList.marginBrain}/pricing`,
          },
          {
            id: 2,
            title: "Cost To Serve",
            url: `${ApplicationBaseUrlList.marginBrain}/cts`,
          },
        ],
      },
      {
        id: 3,
        title: "Strategic Growth",
        items: [
          {
            id: 1,
            title: "Cross Sell",
            url: `${ApplicationBaseUrlList.marginBrain}/cross-sell`,
          },
          {
            id: 2,
            title: "White Label Pricing",
            url: `${ApplicationBaseUrlList.marginBrain}/wlp`,
          },
        ],
      },
    ],
  },
  {
    id: 7,
    title: "SPA Optimizer",
    subMenu: [
      {
        id: 1,
        title: "Overview",
        url: `${ApplicationBaseUrlList.rebateoptimizer}/#/overview`,
      },
      {
        id: 2,
        title: "Leakage Management",
        items: [
          {
            id: 1,
            title: "Leakage ID / Closeout",
            url: `${ApplicationBaseUrlList.rebateoptimizer}/#/leakageManagement`,
          },
        ],
      },
      {
        id: 3,
        title: "Negotiations",
        items: [
          {
            id: 1,
            title: "Cost Intelligence",
            url: `${ApplicationBaseUrlList.rebateoptimizer}/#/costIntelligence`,
          },
          {
            id: 2,
            title: "Negotiation Analytics",
            url: `${ApplicationBaseUrlList.rebateoptimizer}/#/negotiationAnalytics`,
          },
        ],
      },
    ],
  },
];
